module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/zoom-in-39427675861cc906de04fc49a0af889b.svg";